<nav [class]="navbarClass">
  <a class="navbar-brand" [routerLink]="brandRoute">
    <span>
      <img class="logo" src="./assets/images/logo_new.png" />
    </span>
  </a>
  <span class="navbar-site-name" *ngIf="showSiteName">{{ siteName }}</span>

  <!-- Phones only. The bell and profile normally live inside .navbar-collapse,
       which is display:none while collapsed — so with the toggler hidden they
       are unreachable. This surfaces them directly in the bar. Hidden at
       768px and above, where the originals in the collapse are used. -->
  <div class="navbar-mobile-actions">
    <a
      *ngIf="shouldShowNotifications"
      class="nav-link notification-link text-white"
      (click)="toggleNotificationPanel()"
      title="Notifications"
      role="button"
      style="cursor: pointer">
      <i class="fa fa-bell notification-icon"></i>
      <span *ngIf="unreadNotificationCount > 0" class="notification-badge">
        {{ unreadNotificationCount }}
      </span>
    </a>

    <!-- Opens the profile drawer rather than a dropdown: a menu anchored to
         a 30px avatar in the corner is awkward on a phone and has nowhere
         to show the account details. -->
    <button
      type="button"
      class="nav-link mobile-profile-btn"
      (click)="openProfileDrawer()"
      aria-label="Account">
      <img [src]="avatarSrc" class="avatar-img" [alt]="avatarAlt" />
    </button>
  </div>

  <button class="navbar-toggler" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <div id="wwtp" class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
    <ul class="navbar-nav ms-auto">
      <ng-container *ngFor="let item of visibleMenuItems">
        <li
          class="nav-item mt-14px"
          ngbDropdown
          #topDropdown="ngbDropdown"
          [placement]="item.placement || 'bottom-left'"
          (mouseenter)="openDropdownOnHover(topDropdown, $event)"
          (mouseleave)="closeDropdownOnLeave(topDropdown, $event)"
          (openChange)="onDropdownOpenChange(topDropdown, $event)"
          *ngIf="isSubmenu(item); else topLevelLink">
          <a
            class="nav-link text-white"
            [ngClass]="item.linkClass"
            ngbDropdownToggle
            [id]="item.id || item.label">
            <span class="nav-link-label">{{ item.label }}</span>
            <i class="fa fa-angle-down dropdown-chevron" aria-hidden="true"></i>
          </a>
          <ul
            ngbDropdownMenu
            [attr.aria-labelledby]="item.id || item.label"
            [class]="item.menuClass || 'dropdown-menu bg-light top-52px shadow border-none user-menus'">
            <ng-container *ngFor="let child of item.children">
              <ng-container *ngIf="isVisible(child)">
                <li
                  ngbDropdown
                  #childDropdown="ngbDropdown"
                  [placement]="getDropdownPlacement(child, true)"
                  (mouseenter)="openDropdownOnHover(childDropdown, $event, child, true)"
                  (mouseleave)="closeDropdownOnLeave(childDropdown, $event)"
                  (openChange)="onDropdownOpenChange(childDropdown, $event)"
                  *ngIf="isSubmenu(child); else childLeaf">
                  <a
                    class="sub-dropdown"
                    ngbDropdownToggle
                    [id]="child.id || child.label">
                    <span class="sub-dropdown-label">{{ child.label }}</span>
                    <i class="fa fa-angle-right submenu-chevron" aria-hidden="true"></i>
                  </a>
                  <div
                    ngbDropdownMenu
                    [attr.aria-labelledby]="child.id || child.label"
                    [class.open-left]="isSubmenuOpenLeft(child)"
                    [class]="child.menuClass || 'dropdown-menu bg-light user-menus sub-dropdown-menu user_role'">
                    <ng-container *ngFor="let grandChild of child.children">
                      <a
                        *ngIf="isVisible(grandChild)"
                        class="dropdown-item"
                        [ngClass]="grandChild.linkClass"
                        [routerLink]="grandChild.route"
                        [queryParams]="grandChild.queryParams"
                        href="javascript:void(0)"
                        (click)="onItemClick(grandChild, $event)">
                        {{ grandChild.label }}
                      </a>
                      <div
                        class="dropdown-divider"
                        *ngIf="isVisible(grandChild) && grandChild.dividerAfter"></div>
                    </ng-container>
                  </div>
                </li>
                <ng-template #childLeaf>
                  <a
                    class="dropdown-item"
                    [ngClass]="child.linkClass"
                    [class.text-muted]="child.disabled"
                    [routerLink]="child.route"
                    [queryParams]="child.queryParams"
                    href="javascript:void(0)"
                    (click)="onItemClick(child, $event)">
                    {{ child.label }}
                  </a>
                </ng-template>
                <div class="dropdown-divider" *ngIf="child.dividerAfter"></div>
              </ng-container>
            </ng-container>
          </ul>
        </li>

        <ng-template #topLevelLink>
          <li class="nav-item mt-14px" *ngIf="isVisible(item)" (mouseenter)="closeAllDropdowns()">
            <a
              class="nav-link text-white"
              [ngClass]="item.linkClass"
              [class.text-muted]="item.disabled"
              [routerLink]="item.route"
              [queryParams]="item.queryParams"
              href="javascript:void(0)"
              (click)="onItemClick(item, $event)">
              {{ item.label }}
            </a>
          </li>
        </ng-template>
      </ng-container>

      <li class="nav-item notification-nav-item mt-14px" *ngIf="shouldShowNotifications">
        <a
          class="nav-link notification-link text-white"
          (mouseenter)="closeAllDropdowns()"
          (click)="toggleNotificationPanel()"
          title="Notifications"
          style="cursor: pointer;">
          <i class="fa fa-bell notification-icon"></i>
          <span *ngIf="unreadNotificationCount > 0" class="notification-badge">
            {{ unreadNotificationCount }}
          </span>
        </a>
      </li>

      <li
        class="nav-item ms-1"
        ngbDropdown
        #profileDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(profileDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(profileDropdown, $event)"
        (openChange)="onDropdownOpenChange(profileDropdown, $event)">
        <a class="nav-link" ngbDropdownToggle id="userauth" role="button">
          <img [src]="avatarSrc" class="avatar-img" [alt]="avatarAlt" />
        </a>
        <ul
          ngbDropdownMenu
          aria-labelledby="userauth"
          class="dropdown-menu bg-light top-52px logout shadow user-menus">
          <ng-container *ngFor="let item of visibleProfileMenuItems">
            <a
              class="dropdown-item"
              [class.text-muted]="item.disabled"
              [routerLink]="item.route"
              [queryParams]="item.queryParams"
              href="javascript:void(0)"
              (click)="onItemClick(item, $event)">
              <i *ngIf="item.actionId === 'logout'" class="fa fa-power-off"></i>
              {{ item.label }}
            </a>
            <div class="dropdown-divider" *ngIf="item.dividerAfter"></div>
          </ng-container>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<!-- ═══════════════════════════════════════════════════════════════════════
     Phone bottom bar. Replaces the hamburger below 768px and is hidden at
     or above it. Driven by the same permission-filtered menuItems as the
     desktop bar, so nothing is duplicated or hardcoded.
     ═══════════════════════════════════════════════════════════════════ -->
<div class="mobile-tabbar" role="navigation" aria-label="Main">
  <a class="mobile-tab" [routerLink]="brandRoute" (click)="closeMobileSheet()" title="Home">
    <i class="fa fa-home" aria-hidden="true"></i>
    <span class="mobile-tab-label">Home</span>
  </a>

  <a
    class="mobile-tab"
    *ngFor="let item of mobileTabItems; trackBy: trackTab"
    [class.is-active]="activeSheetItem === item"
    [routerLink]="isSubmenu(item) ? null : item.route"
    [queryParams]="item.queryParams"
    href="javascript:void(0)"
    (click)="onMobileTab(item, $event)"
    [title]="item.label">
    <img
      *ngIf="tabImage(item.label) as art; else tabGlyph"
      class="mobile-tab-img"
      [src]="art"
      alt=""
      aria-hidden="true" />
    <ng-template #tabGlyph>
      <i class="fa" [ngClass]="tabIcon(item.label)" aria-hidden="true"></i>
    </ng-template>
    <span class="mobile-tab-label">{{ item.label }}</span>
  </a>

  <button
    type="button"
    class="mobile-tab"
    *ngIf="hasMobileOverflow"
    [class.is-active]="showOverflowSheet"
    (click)="openOverflowSheet()"
    title="More">
    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
    <span class="mobile-tab-label">More</span>
  </button>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════
     Profile drawer — phones only, hidden at 768px and above where the
     avatar dropdown in the collapse is used instead.
     ═══════════════════════════════════════════════════════════════════ -->
<aside class="profile-drawer" *ngIf="showProfileDrawer" aria-label="Account">
  <!-- Tinted band carrying the identity, the way a native account screen does -->
  <header class="profile-hero">
    <button
      type="button"
      class="profile-hero-back"
      (click)="closeProfileDrawer()"
      aria-label="Back">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
    </button>

    <div class="profile-hero-id">
      <img [src]="avatarSrc" class="profile-hero-avatar" [alt]="avatarAlt" />
      <div class="profile-hero-text">
        <div class="profile-hero-titleline">
          <h1 class="profile-hero-name">{{ profileDisplayName }}</h1>
          <span class="profile-hero-role" *ngIf="profileSubtitle">{{ profileSubtitle }}</span>
        </div>
        <div class="profile-hero-contact">
          <span class="profile-hero-line" *ngIf="profilePhone">{{ profilePhone }}</span>
          <span class="profile-hero-line" *ngIf="profileEmail">{{ profileEmail }}</span>
        </div>
      </div>
    </div>
  </header>

  <div class="profile-drawer-body">
    <!-- Actions, minus logout, which gets its own block -->
    <section class="profile-card">
      <ng-container *ngFor="let item of visibleProfileMenuItems">
        <a
          class="profile-row"
          *ngIf="item.actionId !== 'logout'"
          [class.is-disabled]="item.disabled"
          [routerLink]="item.route"
          [queryParams]="item.queryParams"
          href="javascript:void(0)"
          (click)="onProfileDrawerItem(item, $event)">
          <i class="fa profile-row-lead" [ngClass]="profileIcon(item)" aria-hidden="true"></i>
          <span class="profile-row-label">{{ item.label }}</span>
          <i class="fa fa-angle-right profile-row-chevron" aria-hidden="true"></i>
        </a>
      </ng-container>
    </section>

    <section class="profile-card">
      <ng-container *ngFor="let item of visibleProfileMenuItems">
        <a
          class="profile-row is-logout"
          *ngIf="item.actionId === 'logout'"
          [class.is-disabled]="item.disabled"
          href="javascript:void(0)"
          (click)="onProfileDrawerItem(item, $event)">
          <i class="fa fa-power-off profile-row-lead" aria-hidden="true"></i>
          <span class="profile-row-label">{{ item.label }}</span>
        </a>
      </ng-container>
    </section>
  </div>
</aside>

<!-- Sheet holding whichever branch was tapped -->
<div class="mobile-sheet-scrim" *ngIf="isMobileSheetOpen" (click)="closeMobileSheet()"></div>

<div class="mobile-sheet" *ngIf="isMobileSheetOpen">
  <div class="mobile-sheet-grab"></div>

  <div class="mobile-sheet-head">
    <span class="mobile-sheet-title">{{ showOverflowSheet ? "More" : activeSheetItem?.label }}</span>
    <button type="button" class="mobile-sheet-close" (click)="closeMobileSheet()" aria-label="Close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="mobile-sheet-body">
    <!-- More: the top-level items that did not fit in the pill -->
    <ng-container *ngIf="showOverflowSheet">
      <a
        class="mobile-sheet-row"
        *ngFor="let item of mobileOverflowItems; trackBy: trackSheetRow"
        [routerLink]="isSubmenu(item) ? null : item.route"
        [queryParams]="item.queryParams"
        href="javascript:void(0)"
        (click)="onMobileTab(item, $event)">
        <i class="fa mobile-sheet-icon" [ngClass]="tabIcon(item.label)" aria-hidden="true"></i>
        <span>{{ item.label }}</span>
        <i class="fa fa-angle-right mobile-sheet-chevron" *ngIf="isSubmenu(item)" aria-hidden="true"></i>
      </a>
    </ng-container>

    <!-- A drillOnly branch (the merged Reports tab): its children are
         themselves branches, so they render as drill-in rows rather than
         being flattened into groups with nothing under them. -->
    <ng-container *ngIf="!showOverflowSheet && activeSheetItem?.drillOnly">
      <a
        class="mobile-sheet-row"
        *ngFor="let child of activeSheetItem?.children; trackBy: trackSheetRow"
        [routerLink]="isSubmenu(child) ? null : child.route"
        [queryParams]="child.queryParams"
        href="javascript:void(0)"
        (click)="onMobileTab(child, $event)">
        <i class="fa mobile-sheet-icon" [ngClass]="tabIcon(child.label)" aria-hidden="true"></i>
        <span>{{ child.label }}</span>
        <i class="fa fa-angle-right mobile-sheet-chevron" *ngIf="isSubmenu(child)" aria-hidden="true"></i>
      </a>
    </ng-container>

    <!-- A branch: its leaves, then any sub-branches as their own groups -->
    <ng-container *ngIf="!showOverflowSheet && !activeSheetItem?.drillOnly">
      <div
        class="mobile-sheet-group"
        *ngFor="let group of sheetGroups(activeSheetItem); trackBy: trackSheetGroup">
        <div class="mobile-sheet-group-label" *ngIf="group.label">{{ group.label }}</div>
        <a
          class="mobile-sheet-row"
          *ngFor="let leaf of group.items; trackBy: trackSheetRow"
          [class.text-muted]="leaf.disabled"
          [class.is-web-only]="leaf.webOnly"
          [routerLink]="leaf.webOnly ? null : leaf.route"
          [queryParams]="leaf.queryParams"
          href="javascript:void(0)"
          (click)="onSheetLeafClick(leaf, $event)">
          <span>{{ leaf.label }}</span>
          <span class="mobile-sheet-flag" *ngIf="leaf.webOnly">Web only</span>
        </a>
      </div>
    </ng-container>
  </div>
</div>

<div
  *ngIf="isAnyMenuOpen"
  class="menu-backdrop-blur">
</div>

<div
  *ngIf="shouldShowNotifications && isNotificationPanelOpen"
  class="notification-backdrop"
  (click)="onBackdropClick($event)"></div>

<div
  *ngIf="shouldShowNotifications"
  class="notification-panel"
  [class.open]="isNotificationPanelOpen"
  [class.dark-mode]="isDarkMode">
  <div class="notification-panel-header">
    <h4 class="notification-panel-title">
      <i class="fa fa-bell"></i> Notifications
      <span *ngIf="unreadNotificationCount > 0" class="badge badge-danger unread-badge-panel">
        {{ unreadNotificationCount }}
      </span>
    </h4>
    <div class="notification-panel-actions">
      <div class="theme-switch-container">
        <label class="theme-switch-label">
          <i class="fa fa-sun" [class.active]="!isDarkMode"></i>
          <input
            type="checkbox"
            class="theme-switch"
            [checked]="isDarkMode"
            (change)="onThemeToggle()"
            title="Toggle Dark/Light Mode" />
          <span class="theme-switch-slider"></span>
          <i class="fa fa-moon" [class.active]="isDarkMode"></i>
        </label>
      </div>
      <button class="btn btn-sm btn-close-panel" (click)="closeNotificationPanel()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="notification-panel-content">
    <app-notification-list
      #notificationListComponent
      [class.dark-mode]="isDarkMode"
      (notificationClicked)="closeNotificationPanel()">
    </app-notification-list>
  </div>
</div>
